exports = module.exports = require("../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.train-tree .el-cascader-menu {\n  width: 3.5rem;\n  min-width: 0;\n}\n.train-tree .el-cascader-menu ul li {\n  padding: 0;\n}\n.train-tree .el-cascader-menu ul li .el-icon-arrow-right:before {\n  content: \"\";\n}\n.train-tree .el-cascader-menu:last-child .el-cascader-node {\n  padding-right: 0;\n}\n", ""]);

// exports
